module.exports = __webpack_public_path__ + "static/media/logo.e173a394.svg";